export default {
  name: 'dashify:ListItem',
  title: 'List Item',
  owner: 'System',
  solution: '',
  tags: ['html', 'list'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    props: {
      task: 'default task',
    },
    view: [['li', { '.': 'border bg-green-800 p-2' }, '/${ props.task }']],
  },
};
